var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "settings-container" } }, [
    _c(
      "div",
      [
        _c("profile-container", {
          attrs: { saving: _vm.saving },
          on: {
            "allow-save": _vm.handleAllowSave,
            "finish-saving": _vm.handleFinishSaving,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }